const parseQsOptions = (qsOptions) => {
  const { q, sort, page } = qsOptions

  return {
    q,
    sort: sort || 'Relevance',
    page: page ? Number(page) : 1
  }
}

export default parseQsOptions
